import { useAppSelector } from '../../global/hooks';
import {
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalFoot,
	ModalHead,
	SaveButton
} from '../../global/styles';
import {
	selectActiveSection,
	selectActiveSectionId,
	selectView,
	setView
} from '../../store/appSlice';
import { addSection, updateSection } from '../../store/sectionsSlice';
import DeleteSection from './DeleteSection';
import EnabledToggle from './EnabledToggle';
import NameInput from './NameInput';
import RepeatInput from './RepeatInput';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

export default function EditSection() {
	const dispatch = useDispatch();

	const closeModal = () => {
		dispatch(setView('main'));
	};

	const isVisible = useAppSelector(selectView) === 'editSection';
	const activeSectionId = useAppSelector(selectActiveSectionId);
	const activeSection = useAppSelector(selectActiveSection);
	const { enabled = false, name = '', repeatCount = 1 } = activeSection || {};

	const saveRef = useRef<HTMLButtonElement>(null);

	// state
	const [repeats, setRepeats] = useState<number>(1);
	const [sectionName, setSectionName] = useState('');
	const [isSectionEnabled, setIsSectionEnabled] = useState(true);

	const currentSection = {
		repeatCount,
		name: sectionName
	};
	const handleSaveSection = () => {
		dispatch(
			activeSectionId
				? updateSection({
						...currentSection,
						id: activeSectionId,
						enabled: isSectionEnabled,
						repeatCount: repeats
				  })
				: addSection({
						...currentSection,
						id: Date.now(),
						chords: [],
						enabled: true,
						repeatCount: repeats
				  })
		);
		dispatch(setView('main'));
	};

	// when first loading, if editing existing section, load section data
	useEffect(() => {
		if (isVisible) {
			setRepeats(repeatCount);
			if (name != null) {
				setSectionName(name);
			} else {
				setSectionName('');
			}
			setIsSectionEnabled(enabled);
		}
	}, [isVisible, repeatCount, name, enabled]);

	return isVisible ? (
		<Modal>
			<ModalCloseButton
				onClick={closeModal}
				title="close this modal popup"
				aria-label="close this modal poup"
			/>
			<div>
				<ModalHead>{activeSectionId ? 'Edit' : 'Add'} Section</ModalHead>
				<ModalBody>
					<RepeatInput onChange={setRepeats} value={repeats} />
					<NameInput onChange={setSectionName} value={sectionName} />
					{activeSectionId != null && (
						<EnabledToggle onChange={setIsSectionEnabled} value={isSectionEnabled} />
					)}
					<DeleteSection />
				</ModalBody>
			</div>
			<ModalFoot>
				<SaveButton ref={saveRef} onClick={handleSaveSection}>
					{activeSectionId ? 'Save' : 'Add'} Section
				</SaveButton>
			</ModalFoot>
		</Modal>
	) : null;
}
